module.exports = __webpack_public_path__ + "img/person.a3be733c.svg";